import { Component, AfterViewInit, ChangeDetectorRef, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { AppConstants } from 'src/app/constants/app-constants';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { InsightsService } from 'src/app/services/insights.service';
import { Subscription } from 'rxjs';
import { Utility } from 'src/app/utils/app-utils';

@Component({
  selector: 'app-alarm-operator-ratio',
  templateUrl: './alarm-operator-ratio.component.html',
  styleUrls: ['./alarm-operator-ratio.component.scss'],
})
export class AlarmOperatorRatioComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private cdr: ChangeDetectorRef, public insightsService: InsightsService, public authenticationService: AuthenticationService) { }

  dynamicWidth: number = 185;
  dynamicHeight: number = 30;
  dynamicIntervals: number = 30;
  alarmsPercentage: number = 0;
  operatorsPercentage: number = 0;
  totalAlarms: number = 0;
  OperatorsPerformance: number = 0;
  alarmRatio: number = 0;

  private dateRangeSubscription: Subscription;
  private startDate: number | undefined;
  private endDate: number | undefined;
  isSupervisor: boolean = false;
  private resizeObserver: ResizeObserver;
  private resizeDebounceId: any;
  @ViewChild('ratioContainer', { static: true }) ratioContainer: ElementRef<HTMLDivElement>;

  async ngOnInit() {
    this.listenToDateRangeChanges();
  }

  listenToDateRangeChanges() {
    this.dateRangeSubscription = this.insightsService.currentDateRange.subscribe(dateRange => {
      this.startDate = dateRange.startDate;
      this.endDate = dateRange.endDate;
      this.getRatio(this.startDate, this.endDate);
    });
  }

  async getRatio(startDate?: number, endDate?: number) {
    let res = await this.insightsService.getAlarmsManagementOverview(startDate, endDate);
    if (res && res.success && res?.data && res.data?.results) {
      const results = res.data.results;
      this.totalAlarms = results.alarmsForOperators.currentPeriodAlarmsCount;
      this.alarmsPercentage = Math.round(results.alarmsForOperators.percentage);
      this.alarmRatio = results.alarmsForOperators.alarmsRelatedToOperatorsCount;

      this.isSupervisor = this.authenticationService.hasRole(AppConstants.Supervisor);
      if (this.isSupervisor) {
        this.operatorsPercentage = Math.round(results.allOperatorsActivity.percentage);
        this.OperatorsPerformance = results.allOperatorsActivity.totalAlarmsHandledByOperators;
      } else {
        this.operatorsPercentage = Math.round(results.individualOperatorActivity.percentage);
        this.OperatorsPerformance = results.individualOperatorActivity.totalAlarmsHandledByOperator;
      }
    } else {
      this.alarmsPercentage = 0;
      this.operatorsPercentage = 0;
      this.totalAlarms = 0;
      this.OperatorsPerformance = 0;
    }
  }

  ngAfterViewInit(): void {
    const containerElement = this.ratioContainer?.nativeElement;
    if (typeof ResizeObserver !== 'undefined' && containerElement) {
      this.resizeObserver = new ResizeObserver(entries => {
        const latestEntry = entries[entries.length - 1];
        const width = latestEntry?.contentRect?.width;
        if (width === undefined) {
          return;
        }
        if (this.resizeDebounceId) {
          clearTimeout(this.resizeDebounceId);
        }
        this.resizeDebounceId = setTimeout(() => {
          this.updateSvgDimensions(width);
        }, 80);
      });
      this.resizeObserver.observe(containerElement);
    }
    this.cdr.detectChanges();
  }

  private updateSvgDimensions(width?: number) {
    if (width === undefined || width === null || Number.isNaN(width)) {
      return;
    }
    const availableWidth = Math.max(width - 220, 150);
    const clampedWidth = Math.min(Math.max(availableWidth, 180), 520);
    this.dynamicWidth = clampedWidth;

    if (clampedWidth >= 300) {
      this.dynamicHeight = 30;
      this.dynamicIntervals = 60;
    } else if (clampedWidth >= 240) {
      this.dynamicHeight = 30;
      this.dynamicIntervals = 30;
    } else {
      this.dynamicHeight = 30;
      this.dynamicIntervals = 30;
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.resizeDebounceId) {
      clearTimeout(this.resizeDebounceId);
      this.resizeDebounceId = null;
    }
    Utility.Unsubscribe(this.dateRangeSubscription);
  }
}
